module.exports = "/_next/static/images/OgFacebookAds-94cf83e1ad1cde519407d231b82462c1.jpeg";